import { View, Modal, Text, StyleSheet, TouchableOpacity } from "react-native";
import React from "react";
import colors from "@constants/color";
import { normalize } from "@constants/metrics";

const CustomModal = ({
  heading,
  message,
  buttons = [],
  setShowModal,
  onPress = () => {},
  visible,
  fontFamily = true,
  headingFontSize = normalize(18),
  messageFontSize = normalize(14),
  headingFontWeight = "",
}) => {
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={() => {
        if (setShowModal) {
          setShowModal();
        }
      }}
    >
      <View style={styles.mainView}>
        <View style={styles.innerView}>
          {heading ? (
            <Text
              style={{
                fontSize: headingFontSize,
                fontFamily: fontFamily ? "NotoSansDevanagari-SemiBold" : "",
                fontWeight: headingFontWeight,
              }}
            >
              {heading}
            </Text>
          ) : null}
          {message ? (
            <Text
              style={[
                styles.message,
                {
                  fontFamily: fontFamily ? "NotoSansDevanagari-Regular" : "",
                  fontSize: messageFontSize,
                },
              ]}
            >
              {message}
            </Text>
          ) : null}
          {buttons && (
            <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
              {buttons?.map((button, index) => {
                const isApiHit = button.hasOwnProperty("isApi")
                  ? button.isApi
                  : true;

                return (
                  <TouchableOpacity
                    testID={button.text}
                    onPress={() => {
                      if (isApiHit) {
                        onPress();
                      }
                      if (setShowModal) {
                        setShowModal();
                      }
                    }}
                  >
                    <Text
                      style={{
                        fontSize: normalize(14),
                        color: button.color ? button.color : colors.lightBlack,
                        fontFamily: fontFamily
                          ? "NotoSansDevanagari-Regular"
                          : "",
                        marginRight:
                          index + 1 !== buttons.length ? normalize(40) : 0,
                        paddingHorizontal: 8,
                      }}
                    >
                      {button.text}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  mainView: {
    backgroundColor: colors.modalBackground,
    width: "100%",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  innerView: {
    backgroundColor: colors.white,
    width: normalize(328),
    borderRadius: normalize(10),
    padding: normalize(24),
  },
  message: {
    fontSize: normalize(14),
    paddingTop: normalize(16),
    paddingBottom: normalize(24),
    color: colors.lightBlack,
  },
});

export default CustomModal;
